import { ImageIdentifierInfo } from "abweb/service/image/api/ImageIdentifierInfo";
import { ImagePhysicalScale } from "abweb/service/image/api/ImagePhysicalScale";
import { ImageType } from "abweb/service/image/api/ImageType";
import { NamespaceAndId } from "abweb/service/image/api/NamespaceAndId";
export class ResourceUtils {
  /**
   * Indicates the character that is used to designates a reserved dynamic namespace. This may be used to allow
   * dynamic use of Font Awesome characters or loading of images from the database, etc. These namespaces
   * cannot be registered to contain identifiers here.
   *
   * @type {string}
   */
  static isDynamicNamespace(namespace) {
    return namespace.trim().indexOf("!") > -1;
  }

  /**
   * Returns null if this is not a dynamic namespace (namespace contains !) or the namespace if it is
   *
   * @param identifier
   */
  static extractNameSpaceAndId(identifier) {
    let nameSpace = null;
    let imageId = identifier;
    if (identifier.indexOf(":") > -1) {
      const parts = imageId.split(":");
      nameSpace = parts[0];
      imageId = parts[1];
    }
    return new NamespaceAndId(nameSpace, imageId);
  }

  /**
   * Returns null if this is not a dynamic namespace (namespace contains !) or the namespace if it is
   *
   * @param identifier
   */
  static extractId(identifier) {
    let nameSpace = null;
    if (identifier.indexOf(":") > -1) {
      nameSpace = identifier.split(":")[0];
    }
    return nameSpace;
  }

  /**
   * Convenience method for producing a new ImageIdentifierInfo of type IMAGE
   * @param nameSpace
   * @param id
   * @param path
   * @param width
   * @param height
   * @returns {ImageIdentifierInfo}
   */
  static newImage(nameSpace, id, path, width = NaN, height = NaN) {
    return new ImageIdentifierInfo(nameSpace, id, ImageType.IMAGE, [new ImagePhysicalScale(path, width, height)]);
  }

  /**
   *  Convenience method for producing a new ImageIdentifierInfo of type SVG
   * @param nameSpace
   * @param id
   * @param path
   * @returns {ImageIdentifierInfo}
   */
  static newSvg(nameSpace, id, path) {
    return new ImageIdentifierInfo(nameSpace, id, ImageType.SVG, [new ImagePhysicalScale(path)]);
  }

  /**
   * Convenience method for producing a new ImageIdentifierInfo of type FONT_BASED using default Font Awesome classes
   * @param nameSpace
   * @param id
   * @param spanClasses
   * @returns {ImageIdentifierInfo}
   */
  static newDefaultFontAwesome(nameSpace, id, spanClasses = null) {
    return new ImageIdentifierInfo(nameSpace, id, ImageType.FONT_BASED, null, "fa fa-" + id, spanClasses);
  }

  /**
   * Convenience method for producing a new ImageIdentifierInfo of type FONT_BASED using custom classes
   * @param nameSpace
   * @param id
   * @param elementClasses
   * @param spanClasses
   * @returns {ImageIdentifierInfo}
   */
  static newCustomFontBased(nameSpace, id, elementClasses, spanClasses = null) {
    return new ImageIdentifierInfo(nameSpace, id, ImageType.FONT_BASED, null, elementClasses, spanClasses);
  }
}
//# sourceMappingURL=ResourceUtils.js.map
